import { FieldValues } from 'react-hook-form'

export enum DelegationType {
    NO_DELEGATE = 'noDelegate',
    PERMANENT = 'permanent',
    TEMPORARY = 'temporary',
}

export interface UserDelegationFormData extends FieldValues {
    delegatedUserId: string | null
    startAt: Date | null
    expirationAt: Date | null
    delegationType: DelegationType
}
